// import { Search, SentimentDissatisfied } from "@mui/icons-material";
// import {
//   CircularProgress,
//   Grid,
//   InputAdornment,
//   TextField,
// } from "@mui/material";
// //import Paper from "@mui/material/Paper";
// import { Box, Container } from "@mui/system";
// import axios from "axios";
// import { useSnackbar } from "notistack";
// import React, { useEffect, useState } from "react";
// import { config } from "../App";
// import Footer from "./Footer";
// import Header from "./Header";
// import ProductCard from "./ProductCard";
// import Cart from "./Cart";
// import "./Products.css";
// import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
// import { generateCartItemsFrom } from "./Cart";

// /**
//  * @typedef {Object} CartItem -  - Data on product added to cart
//  *
//  * @property {string} name - The name or title of the product in cart
//  * @property {string} qty - The quantity of product added to cart
//  * @property {string} category - The category that the product belongs to
//  * @property {number} cost - The price to buy the product
//  * @property {number} rating - The aggregate rating of the product (integer out of five)
//  * @property {string} image - Contains URL for the product image
//  * @property {string} _id - Unique ID for the product
//  */


// const Products = () => {
//   const [apiProduct, setApiProducts] = useState([]);

//   const [cartProducts, setCartProducts] = useState([]);

//   const [displayCartItems, setDisplayCartItems] = useState([])

//   const [NoProductsFound, setNoProductsFound] = useState(false);

//   const [debounceTimeout, setDebounceTimeout] = useState(500);

//   const [isLoggedIn, setIsLoggedIn] = useState();

  
//   const { enqueueSnackbar } = useSnackbar();

//   const [loading, setLoading] = useState(false);
//   // const show = true;
//   // let username;
//   // if (localStorage.getItem("username") === null) {
//   // } else {
//   //   let data = localStorage.getItem("username");
//   //   username = data;
//   // }

//   useEffect(() => {
//     performAPICall();
//     fetchCart(localStorage.getItem("token"));
//       if (localStorage.getItem("token")) {
//         setIsLoggedIn(true);
//       } else {
//         setIsLoggedIn(false);
//       }
    
//   }, []);

//   useEffect(() => {
//     setDisplayCartItems(generateCartItemsFrom(cartProducts, apiProduct));
//   }, [cartProducts, apiProduct]);

//   //console.log("apiProduct::", apiProduct);

//  // console.log(localStorage.getItem("token"));

//   // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
//   /**
//    * Make API call to get the products list and store it to display the products
//    *
//    * @returns { Array.<Product> }
//    *      Array of objects with complete data on all available products
//    *
//    * API endpoint - "GET /products"
//    *
//    * Example for successful response from backend:
//    * HTTP 200
//    * [
//    *      {
//    *          "name": "iPhone XR",
//    *          "category": "Phones",
//    *          "cost": 100,
//    *          "rating": 4,
//    *          "image": "https://i.imgur.com/lulqWzW.jpg",
//    *          "_id": "v4sLtEcMpzabRyfx"
//    *      },
//    *      {
//    *          "name": "Basketball",
//    *          "category": "Sports",
//    *          "cost": 100,
//    *          "rating": 5,
//    *          "image": "https://i.imgur.com/lulqWzW.jpg",
//    *          "_id": "upLK9JbQ4rMhTwt4"
//    *      }
//    * ]
//    *
//    * Example for failed response from backend:
//    * HTTP 500
//    * {
//    *      "success": false,
//    *      "message": "Something went wrong. Check the backend console for more details"
//    * }
//    */

//   const performAPICall = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${config.endpoint}/products`);
//       if (response.status === 200) {
//         setApiProducts(response.data);
//         //console.log("hi from perform::", response.data)
//         setLoading(false);
//       }

//     } catch (error) {
//       if (error.response.status === 404) {
//         enqueueSnackbar(error.response.data.message);
//       } else {
//         enqueueSnackbar(
//           "Something went wrong. Check that the backend is running, reachable and returns valid JSON.",
//           { variant: "error" }
//         );
//       }
//     }
//   };

//   // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
//   /**
//    * Definition for search handler
//    * This is the function that is called on adding new search keys
//    *
//    * @param {string} text
//    *    Text user types in the search bar. To filter the displayed products based on this text.
//    *
//    * @returns { Array.<Product> }
//    *      Array of objects with complete data on filtered set of products
//    *
//    * API endpoint - "GET /products/search?value=<search-query>"
//    *
//    */

//   const performSearch = async (text) => {
//     try {
//       const response = await axios.get(
//         `${config.endpoint}/products/search?value=${text}`
//       );
//       if (response.status === 200) {
//         setApiProducts(response.data);
//         setNoProductsFound(false);
//       }
//       return response.data;
//     } catch (error) {
//       if (error.response.status === 404) {
//         //  console.log("error search:::", error.response);
//         enqueueSnackbar("No Products Found");
//         setNoProductsFound(true);
//       }
//     }
//   };

//   // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
//   /**
//    * Definition for debounce handler
//    * With debounce, this is the function to be called whenever the user types text in the searchbar field
//    *
//    * @param {{ target: { value: string } }} event
//    *    JS event object emitted from the search input field
//    *
//    * @param {NodeJS.Timeout} debounceTimeout
//    *    Timer id set for the previous debounce call
//    \]*
//    */

//   const debounceSearch = (event, debounceTimeout1) => {
//     //  setInputSearch(event.target.value);
//     if (debounceTimeout) {
//       clearTimeout(debounceTimeout);
//     }
//     const timeout = setTimeout(() => {
//       performSearch(event.target.value);
//     }, debounceTimeout1);
//     setDebounceTimeout(timeout);
//   };

//   /**
//    * Perform the API call to fetch the user's cart and return the response
//    *
//    * @param {string} token - Authentication token returned on login
//    *
//    * @returns { Array.<{ productId: string, qty: number }> | null }
//    *    The response JSON object
//    *
//    * Example for successful response from backend:
//    * HTTP 200
//    * [
//    *      {
//    *          "productId": "KCRwjF7lN97HnEaY",
//    *          "qty": 3
//    *      },
//    *      {
//    *          "productId": "BW0jAAeDJmlZCF8i",
//    *          "qty": 1
//    *      }
//    * ]
//    *
//    * Example for failed response from backend:
//    * HTTP 401
//    * {
//    *      "success": false,
//    *      "message": "Protected route, Oauth2 Bearer token not found"
//    * }
//    */
//   const fetchCart = async (token) => {
//     if (!token) return;

//     try {
//       // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
//       const response = await axios.get(`${config.endpoint}/cart`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       // if (response.status === 200) {
//         const data = await response.data
//         setCartProducts(data)
//       // }

//       // console.log("khiladi::", response);
//     } catch (err) {
//       if (err.response && err.response.status === 400) {
//         enqueueSnackbar(err.response.data.message, { variant: "error" });
//       } else {
//         enqueueSnackbar(
//           "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
//           {
//             variant: "error",
//           }
//         );
//       }
//       return null;
//     }
//   };

//   const updateCartItems = (cartData, products) => {
//     const cartItems = generateCartItemsFrom(cartData, products);
//     setCartProducts(cartItems);
//   };

//   // TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
//   /**
//    * Return if a product already is present in the cart
//    *
//    * @param { Array.<{ productId: String, quantity: Number }> } items
//    *    Array of objects with productId and quantity of products in cart
//    * @param { String } productId
//    *    Id of a product to be checked
//    *
//    * @returns { Boolean }
//    *    Whether a product of given "productId" exists in the "items" array
//    *
//    */

//   const isItemInCart = (items, productId) => {
//     for (let item of items) {
//       if(item.productId===productId){
//         return true;
//       }
//     }
//     return false;
//   };
 
//   /**
//    * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
//    *
//    * @param {string} token
//    *    Authentication token returned on login
//    * @param { Array.<{ productId: String, quantity: Number }> } items
//    *    Array of objects with productId and quantity of products in cart
//    * @param { Array.<Product> } products
//    *    Array of objects with complete data on all available products
//    * @param {string} productId
//    *    ID of the product that is to be added or updated in cart
//    * @param {number} qty
//    *    How many of the product should be in the cart
//    * @param {boolean} options
//    *    If this function was triggered from the product card's "Add to Cart" button
//    *
//    * Example for successful response from backend:
//    * HTTP 200 - Updated list of cart items
//    * [
//    *      {
//    *          "productId": "KCRwjF7lN97HnEaY",
//    *          "qty": 3
//    *      },
//    *      {
//    *          "productId": "BW0jAAeDJmlZCF8i",
//    *          "qty": 1
//    *      }
//    * ]
//    *
//    * Example for failed response from backend:
//    * HTTP 404 - On invalid productId
//    * {
//    *      "success": false,
//    *      "message": "Product doesn't exist"
//    * }
//    */
//   // const addToCart = async (productId, increment = false, decrement = false) => {
//   //   if (!isLoggedIn) {
//   //     enqueueSnackbar("Login to add an item to the Cart", {
//   //       variant: "warning",
//   //     });
//   //     return;
//   //   };

//   //   let cartItem = displayCartItems.filter((item) => {
//   //    console.log(item)
//   //    return item.productId === productId;
//   //  });

//   //  if (cartItem.length > 0 && increment === false && decrement === false) {
//   //    enqueueSnackbar(
//   //      "Item already in cart. Use the cart sidebar to update quantity or remove item.",
//   //      { variant: "warning" }
//   //    );
//   //    return;
//   //  }

//   //   const product = {
//   //     productId: productId,
//   //     qty: 0,
//   //   };

//   //  if (increment === true) {
//   //    product["qty"] = Number(cartItem[0].qty) + 1;
//   //  } else if (decrement === true && cartItem[0].qty >=1) {
//   //    product["qty"] = Number(cartItem[0].qty) - 1;
//   //  } else {
//   //    product["qty"] = 1;
//   //  }

//   //   try {
//   //     const token = localStorage.getItem("token");
//   //     const res = await axios.post(
//   //       `${config.endpoint}/cart`,
//   //       {
//   //         productId: product.productId,
//   //         qty: product.qty,
//   //       },
//   //       {
//   //         headers: {
//   //           Authorization: `Bearer ${token}`,
//   //         },
//   //       }
//   //     );
//   //     if (res.status === 200) {
//   //       setLoading(false);
//   //       const data = await res.data;
//   //       setCartProducts(data);
//   //     }
//   //   } catch (error) {
//   //     if (error.toString() === "Error: Request failed with status code 404") {
//   //       enqueueSnackbar("Product Doesn't exist.", { variant: "error" });
//   //     } else {
//   //       enqueueSnackbar("something went wrong", { variant: "error" });
//   //     }
//   //   }
//   // };

// //////////////////////////////////
//   const addToCart = async (
//     token,
//     items,
//     products,
//     productId,
//     qty,
//     options = { preventDuplicate: false }
//   ) => {
//     if (!token) {
//       enqueueSnackbar("Login to add an item to the Cart", {
//         variant: "warning",
//       });
//       return;
//     }
//     if (options["preventDuplicate"]) {
//       if (isItemInCart(items, productId)) {
//         enqueueSnackbar(
//           "Item already in cart. Use the cart sidebar to update quantity or remove item.",
//           {
//             variant: "warning",
//           }
//         );
//         return;
//       }
//     }

  


//     try {
//       const {data} = await axios.post(
//         `${config.endpoint}/cart`,
//         {
//           productId: productId,
//           qty: qty,
//         },
        
//         {
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );
      
    
     
//     setDisplayCartItems( generateCartItemsFrom(data, apiProduct));
//     } catch (e) {
//       if (e.response && e.response.status === 400) {
//         enqueueSnackbar(e.response.data.message, { variant: "error" });
//       } else {
//         enqueueSnackbar(
//           "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
//           {
//             variant: "error",
//           }
//         );
//       }
//       return null;
//     }
//   };
  


//   return (
//     <div>
//       <Header>
//         <TextField
//           className="search-desktop"
//           size="small"
//           InputProps={{
//             className: "search",
//             endAdornment: (
//               <InputAdornment position="end">
//                 <Search color="primary" />
//               </InputAdornment>
//             ),
//           }}
//           placeholder="Search for items/categories"
//           name="search"
//           onChange={(e) => {
//             debounceSearch(e, 500);
//           }}
//         />
//       </Header>
//       <TextField
//         className="search-mobile"
//         size="small"
//         fullWidth
//         InputProps={{
//           endAdornment: (
//             <InputAdornment position="end">
//               <Search color="primary" />
//             </InputAdornment>
//           ),
//         }}
//         placeholder="Search for items/categories"
//         name="search"
//         onChange={(e) => {
//           debounceSearch(e, 500);
//         }}
//       />
//       <Grid container sx={{ marginBottom: 1 }}>
//         <Grid item className="product-grid">
//           <Box className="hero">
//             <p className="hero-heading">
//               India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
//               to your door step
//             </p>
//           </Box>
//         </Grid>
//       </Grid>

//       {!NoProductsFound ? (
//         <div>
//           {loading ? (
//             <>
//               <Box className="loading" sx={{ margin: "0 auto" }}>
//                 <CircularProgress />
//                 <div>Loading Products</div>
//               </Box>
//             </>
//           ) : (
//             <Grid
//               container
//               sx={{ m: 2 }}
//               rowSpacing={1}
//               columnSpacing={{ xs: 1, sm: 1, md: 1 }}
//             >
//               {apiProduct?.map((item) => {
//                 return (
//                   <Grid key={item._id} item xs={6} md={3} lg={3}>
//                     {/* <ProductCard product={item} handleAddToCart={addToCart} /> */}
//                     <ProductCard product={item} handleAddToCart={async () =>await addToCart(
//                                       localStorage.getItem("token"),
//                                       displayCartItems,
//                                       apiProduct,
//                                       item._id,
//                                       1,
//                                    { preventDuplicate: true }
//                                                    )
//                                                   }
//                       />

//                   </Grid>
//                 );
//               })}
//             </Grid>
//           )}
//         </div>
//       ) : (
//         <div style={{ textAlign: "center" }}>
//           <SentimentVeryDissatisfiedIcon />
//           <span>
//             <h5>No Products Found</h5>
//           </span>
//         </div>
//       )}
//       {localStorage.getItem('token') ? (
//         <Grid item sm={12} md={3} lg={3} sx={{ backgroundColor: "#E9F5E1" }}>
//           <Cart
//             items={displayCartItems}
//             products={apiProduct}
//             handleQuantity={addToCart}
//             hasCheckoutButton={true}
//           />
//         </Grid>
//       ) : null }
//       <Footer />
//     </div>
//   );
// };

// export default Products;



//////////////////////////////////////////////////////////////////////////////////////////



import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Cart from "./Cart";
import {generateCartItemsFrom} from "./Cart";

//Item styling for cards
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product


/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * 
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */


const Products = () => {

  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [dataArray, setDataArray] = useState([]);
  const [debounceTimeout, setDebounceTimeout] = useState(0);
  const [fetchedcart, setFetchedcart] = useState([]);
  const [cartList, setCartList] = useState([]);

  useEffect(() => {
    // code to run after render goes here
    const callApi = async () => {
      setLoading(true)
      const getProducts = await performAPICall();
      setLoading(false)
      setDataArray(getProducts);       
      if(localStorage.getItem('username')){     
      const getCart= await fetchCart(localStorage.getItem("token"))     
      setFetchedcart(getCart)
      setCartList(generateCartItemsFrom(getCart,getProducts))
      }
      // console.log("inside useeffect",fetchedcart,res)
    };
    callApi();
  }, []);

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  const performAPICall = async () => {

    try {
      setLoading(true);
      const url = config.endpoint + '/products';
      const response = await axios.get(url);
      if(response.status === 200 || response.status === 201)
        setDataArray(response.data);
      
      setLoading(false);
      return response.data;
    } catch (error) {
      enqueueSnackbar(error.response.data.message, { variant: "error" });
    }
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
    let erres = null;
    try{
      const url = config.endpoint + `/products/search?value=${text}`;
      const response = await axios.get(url);
      
      if (response) {
        return response.data;
      }
    }catch(error){
      if (error.response) {
        erres = error.response;
      } else {
        console.log(error);
      }
    }
    if(erres)
      return erres.data;
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  const debounceSearch = (event, debounceTimeout) => {
    if (debounceTimeout !== 0) {
      clearTimeout(debounceTimeout);
    }
    const timeout = setTimeout(async () => {
      setDataArray(await performSearch(event.target.value));
    }, 500);
    setDebounceTimeout(timeout);
  };

   /**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */
    const fetchCart = async (token) => {
      if (!token) return;
  
      try {
        // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
        const url = config.endpoint + "/cart";
        const response = await axios.get(url, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        //console.log("cart data response ::", response);
        return response.data;
      } catch (e) {
        if (e.response && e.response.status === 400) {
          enqueueSnackbar(e.response.data.message, { variant: "error" });
        } else {
          enqueueSnackbar(
            "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
            {
              variant: "error",
            }
          );
        }
        return null;
      }
    };
  
  
    // TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
    /**
     * Return if a product already is present in the cart
     *
     * @param { Array.<{ productId: String, quantity: Number }> } items
     *    Array of objects with productId and quantity of products in cart
     * @param { String } productId
     *    Id of a product to be checked
     *
     * @returns { Boolean }
     *    Whether a product of given "productId" exists in the "items" array
     *
     */
    const isItemInCart = (items, productId) => {
      const prodIds = items.map((item)=>{
        return item.productId;
      })    
      return (prodIds.includes(productId));  
    };
  
    /**
     * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
     *
     * @param {string} token
     *    Authentication token returned on login
     * @param { Array.<{ productId: String, quantity: Number }> } items
     *    Array of objects with productId and quantity of products in cart
     * @param { Array.<Product> } products
     *    Array of objects with complete data on all available products
     * @param {string} productId
     *    ID of the product that is to be added or updated in cart
     * @param {number} qty
     *    How many of the product should be in the cart
     * @param {boolean} options
     *    If this function was triggered from the product card's "Add to Cart" button
     *
     * Example for successful response from backend:
     * HTTP 200 - Updated list of cart items
     * [
     *      {
     *          "productId": "KCRwjF7lN97HnEaY",
     *          "qty": 3
     *      },
     *      {
     *          "productId": "BW0jAAeDJmlZCF8i",
     *          "qty": 1
     *      }
     * ]
     *
     * Example for failed response from backend:
     * HTTP 404 - On invalid productId
     * {
     *      "success": false,
     *      "message": "Product doesn't exist"
     * }
     */
    const addToCart = async (
      token,
      items,
      products,
      productId,
      qty,
      options = { preventDuplicate: false }
    ) => {
      try {
        // console.log(token,items,products,productId,qty,options)
        if (!token) {
          enqueueSnackbar("Login to add an item to the Cart", {
            variant: "error",
          });
        } else if (options.preventDuplicate && isItemInCart(items, productId)) {        
            enqueueSnackbar(
              "Item already in cart. Use the cart sidebar to update quantity or remove item.",
              { variant: "error" }
            );        
        } else {
          //console.log(token,items,products,productId,qty,options)
          const res = await axios.post(
            `${config.endpoint}/cart`,
            { productId: productId, qty: qty },
            {
              headers: { Authorization: "Bearer " + token }
            }
          );
          //console.log(res.data)
          setFetchedcart(res.data);
          setCartList(generateCartItemsFrom(res.data, products));
          // console.log("inside useeffect",fetchedcart,res)
        }
      } catch (e) {
        if (e.response) {
          enqueueSnackbar(e.response.data.message, { variant: "error" });
        }
      }
    };
  
  return (
    <div>
      <Header hasHiddenAuthButtons={true}>
        {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}
        <TextField
        className="search-desktop"
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        onChange={(e) => {
          debounceSearch(e, debounceTimeout);
        }}
        />
      </Header>

      {/* Search view for mobiles */}
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        onChange={(e) => {
          debounceSearch(e, debounceTimeout);
        }}
      />
      <Grid container>
        <Grid item md={window.localStorage.getItem("username")?9:12}>
          <Grid container>
            <Grid item className="product-grid">
              <Box className="hero">
                <p className="hero-heading">
                  India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
                  to your door step
                </p>
              </Box>
            </Grid>
            </Grid>
            {loading ? (
              <Box display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
                <p>Loading Products...</p>
              </Box>
            ) : ( dataArray.length === 0 ? (
              <Box spacing={2} className="loading">
                <SentimentDissatisfied />
                <p>No products found</p>
              </Box>
            ) : (
              <Grid container spacing={2}>
                      {dataArray.map((data)=>{
                        return (
                          <Grid item xs={6} md={3} key={data._id}>
                            <Item>
                              <ProductCard product={data} handleAddToCart={()=>addToCart(
                  localStorage.getItem("token"),fetchedcart,dataArray,data._id,1,{preventDuplicate:true}
                )} key={data._id}/>
                            </Item>
                          </Grid>
                          );
                        })
                      }
                  </Grid>
              )
            )}
        </Grid>
        {window.localStorage.getItem("username") && 
          <Grid item md={3}>
            <Cart products={dataArray} items={cartList} handleQuantity={addToCart} />
          </Grid>
        }
      </Grid>
      <Footer />
    </div>
  );
};

export default Products;
